module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-prize-01-dcdb54e2b6ef6d7f98d89114954402b4.svg";